import { combineReducers } from '@reduxjs/toolkit'

import { reducers } from '@gocanvas/client'
import { clientSettingsReducer } from 'apps/web-forms/store/reducers/settings/clientSettings'

const rootReducer = combineReducers({
  ...reducers,
  clientSettings: clientSettingsReducer,
})

export default rootReducer
